import { useQuery } from 'react-query';
import { Dayjs } from 'dayjs';
import { useMemo } from 'react';
import { API_QUERIES, SurveyFeedbackStatus, SurveyReadStatus } from '@/constants';
import { BookingCalendarEventDtoPaginationResult } from '@/common/api/wisoryApiClient';
import { getWaitingFeedbackSessions } from '@/common/services';
import { useAuth } from '../useAuth';
import useApplicationSettings from '../useApplicationSettings';

type PURPOSE = 'advisor-incompleted-feedbacks' | 'advisor-all-feedbacks' | 'user-feedbacks';

export const useWaitingForFeedbackQuery = ({
  fromDate,
  purpose,
  onSuccess = () => {},
}: {
  fromDate?: Dayjs;
  purpose: PURPOSE;
  onSuccess?: (data: BookingCalendarEventDtoPaginationResult) => void;
}) => {
  const { isAdvisor } = useAuth();
  const { appSettings } = useApplicationSettings();
  const statuses = useMemo(() => {
    if (purpose === 'advisor-incompleted-feedbacks') {
      return [SurveyFeedbackStatus.None, SurveyFeedbackStatus.Draft];
    }

    if (purpose === 'user-feedbacks') {
      return [SurveyFeedbackStatus.Completed];
    }

    return [SurveyFeedbackStatus.None, SurveyFeedbackStatus.Draft, SurveyFeedbackStatus.Completed];
  }, [purpose]);
  const readStatuses = useMemo(() => {
    if (purpose === 'advisor-incompleted-feedbacks') {
      return [SurveyReadStatus.None, SurveyReadStatus.Read, SurveyReadStatus.UnRead];
    }

    if (purpose === 'user-feedbacks') {
      return [SurveyReadStatus.UnRead];
    }

    return [SurveyReadStatus.None, SurveyReadStatus.Read, SurveyReadStatus.UnRead];
  }, [purpose]);
  const queryKey = useMemo(() => {
    if (fromDate) {
      return [
        API_QUERIES.GET_WAITING_FEEDBACK,
        { periodStartDate: fromDate.format('YYYY-MM-DD'), statuses },
      ];
    }

    return [API_QUERIES.GET_WAITING_FEEDBACK];
  }, [fromDate, statuses]);

  const waitForFeedbackQuery = useQuery({
    queryKey,
    queryFn: () =>
      getWaitingFeedbackSessions(
        {
          //periodStartDate: fromDate ? fromDate.toISOString() : undefined,
          pageSize: 100,
          statuses,
          readStatuses,
        },
        isAdvisor
      ),
    onSuccess,
    enabled: appSettings.isFeedbackFeatureEnabled,
  });

  return waitForFeedbackQuery;
};
